import styled from 'styled-components/macro';

import { PopupTextArea, ErrorMessage } from '../Popups.styles';
import { DropdownSelect } from '../../common/formElements';

export const ReasonDropdownSelect = styled(DropdownSelect)`
  margin: 0 auto;
`;

export const ValidationErrorMessage = styled(ErrorMessage)`
  margin-bottom: 5px;
`;

export const CustomMessageTextArea = styled(PopupTextArea)`
  margin-top: 10px;
  min-height: 70px;
`;

export const StyledSubheading = styled.p`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: normal;
  text-align: left;
  font-size: 11px;
  line-height: 16px;
  color: #313f5a;
  margin: 5px 0px 0px;
`;
